import React, { MutableRefObject } from "react";


export function ProgressBar({barActivate,progressNumber}:{barActivate: boolean,progressNumber: number | MutableRefObject<number>}) 
{
    const progressValue = typeof progressNumber === "number" ? progressNumber : progressNumber.current;
    return (
    <>
      {barActivate && (
        <div className="w-full mt-2 h-4 bg-gray-200 rounded-lg border border-gray-400 relative overflow-hidden">
          <div
            className="h-full bg-green-500 rounded-lg transition-all duration-300 ease-out"
            style={{ width: `${progressValue}%` }}
          />
          <span className="absolute inset-0 flex items-center justify-center text-xs font-medium text-black">
            {progressValue}%
          </span>
        </div>
      )}
    </>
  );
}